// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .user-detail-header .header-button-wrapper {
     display: flex;
     flex-direction: row;
     margin-top: 5px;

 }

 .user-detail-header .header-button-wrapper>button:first-child {
     margin-right: 20px !important;
 }

 .user-detail-header .header-button-wrapper>button:first-child:hover {
     cursor: auto;
 }

 .user-detail-header .header-button-wrapper>button:nth-child(2):hover {
     opacity: 0.8 !important;
 }

 .user-info-subcontainer {
     display: flex;
     flex-direction: row;
     justify-content: space-between;
 }



 /**********common***********************/
 .user-info-subcontainer .first-box,
 .user-info-subcontainer .second-box,
 .user-info-subcontainer .third-box {
     display: flex;
     flex: 1 1;
     flex-direction: column;
     margin-right: 25px;
 }

 .user-info-subcontainer .third-box {
     margin-right: 0px;
 }


 .user-info-subcontainer .third-box .client-coach-feedback-box,
 .user-info-subcontainer .third-box .client-history-box,
 .user-info-subcontainer .second-box .client-health-box,
 .user-info-subcontainer .second-box .client-report-box,
 .user-info-subcontainer .first-box .client-history-box,
 .user-info-subcontainer .first-box .client-intro-box {
     height: 435px;
     /* overflow: auto; */
     margin-bottom: 31px;
 }


 .common-card {
     border-radius: 15px;
     background: var(--white);
     box-shadow: 0px 18px 40px 0px rgba(112, 144, 176, 0.12);
     /* border: 1px solid red; */
     padding: 18px;
 }

 .common-card .text-wrapper-2 {
     color: var(--light-black);
     font-family: "DM Sans", Helvetica;
     font-size: 22px;
     font-weight: 700;
     line-height: 32px;
 }

 .text-wrapper-1 {
     color: var(--light-black);
     font-family: var(--Inter-Bold700);
     font-size: 18px;
     line-height: 28px;
     letter-spacing: -0.36px;
     margin-bottom: 15px !important;
 }

 .text {
     color: var(--text-color);
     font-family: var(--inter-Medium500);
     font-size: 16px;
     line-height: 26px;
     letter-spacing: -0.32px;
     white-space: pre-wrap;
     text-align: justify;
     word-break: break-word;
 }

 .question-title {
     color: var(--light-black);
     font-family: var(--inter-Medium500);
     font-size: 14px;
     line-height: 26px;
     letter-spacing: -0.28px;
 }

 .date {
     color: var(--text-color);
     text-align: center;
     font-family: var(--inter-Medium500);
     font-size: 14px;
     line-height: 26px;
     letter-spacing: -0.28px;
     margin-bottom: 30px;
 }


 /* width */
 .internal-scroll::-webkit-scrollbar {
     width: 3px;
 }

 /* Track */
 .internal-scroll::-webkit-scrollbar-track {
     background: #f1f1f1;
     margin: 10px 0px;
     border-radius: 15px;
 }

 /* Handle */
 .internal-scroll::-webkit-scrollbar-thumb {
     /* background: var(--purple); */
     background: var(--disbaled-color);
     border-radius: 15px;
 }

 /* Handle on hover */
 /* ::-webkit-scrollbar-thumb:hover {
    background: #555;
} */



 /*******************First box styles start************/
 .user-info-subcontainer .first-box {
     /* margin-right: 31px; */
 }

 .user-info-subcontainer .first-box .client-info-box {
     min-height: 750px;
 }


 /********************first box style end &&&& second box start****************/
 .user-info-subcontainer .second-box {
     /* margin-right: 31px; */
 }

 /******************* second box style end &&&&& third box start ************/

 .user-info-subcontainer .third-box .client-history-box .text-wrapper-2 {
     margin-bottom: 16px;
 }

 .user-info-subcontainer .third-box .client-history-box .date-container {
     display: flex;
     flex-direction: row;
     justify-content: space-between;
 }


 .user-info-subcontainer .third-box .client-history-box .active-question-wrapper {
     margin-bottom: 10px;
 }

 .user-info-subcontainer .third-box .client-coach-feedback-box .feadback-header {
     display: flex;
     flex-direction: row;
     justify-content: space-between;
     margin-bottom: 15px;
     padding: 0px 18px;
 }

 .addfeedback-button {
     width: 91.654px !important;
     height: 35px !important;
     padding: 0px 8px;
     display: flex;
     justify-content: center;
     align-items: center;
     border-radius: 12px !important;
     font-size: 18px !important;
     background: var(--field-background) !important;
     border: none;
 }

 .addfeedback-button:hover {
     cursor: pointer;
     opacity: 0.8;
 }

 .addfeedback-button img {
     width: 18px;
     height: 17px;
 }

 .client-coach-feedback-box .feedback-list-wrapper {
     display: flex;
     flex-direction: column;
     overflow: auto;
     flex: 1 1;
     padding: 0px 18px;

 }

 /********************third box end ****************************/



 .client-detail-wrapper {
     margin-top: 31px;
 }

 .client-detail-wrapper .item-wrapper {
     display: flex;
     flex-direction: row;
     justify-content: space-between;
     align-items: center;
     margin-bottom: 15px;
 }

 .client-detail-wrapper .item-wrapper .sub-item-wrapper {
     width: 100%;
     display: flex;
     flex-direction: row;
     align-items: center;
 }

 .client-detail-wrapper .item-wrapper .sub-item-wrapper .sub-item-wrapper-1 {
     display: flex;
     flex-direction: row;
     align-items: center;
     width: 60%;
     justify-content: space-between;
     /* margin-right: 20px; */
 }

 .client-detail-wrapper .item-wrapper .sub-item-wrapper .sub-item-wrapper-2 {
     display: flex;
     flex-direction: row;
     align-items: center;
     width: 40%;
     align-self: center;
 }

 .client-detail-wrapper .item-wrapper .sub-item-wrapper .key {
     /* width: 150px; */
     width: auto;
 }


 .client-detail-wrapper .item-wrapper .sub-item-wrapper .sub-item-wrapper-1 .overlap-3 {
     margin-left: 92px;
     margin-bottom: 0px;
     width: 50%;
 }

 .client-detail-wrapper .item-wrapper .sub-item-wrapper-2 .key {
     width: 50px !important;
     margin-left: 20px !important;
 }

 .client-detail-wrapper .item-wrapper .sub-item-wrapper .sub-item-wrapper-2 .overlap-3 {
     margin-bottom: 0px;
     width: 100% !important;
 }

 .item-wrapper.address-wrapper .key {
     align-self: flex-start;
 }

 .item-wrapper .address-overlap-3-wrapper {
     display: flex;
     flex-direction: row;
     justify-content: space-between;
     width: 70%;
     flex-wrap: wrap;

 }

 .item-wrapper .address-overlap-3-wrapper .overlap-3 {
     width: 48%;
     margin-bottom: 15px;
 }
 .tabHeader{
    display: flex !important;
    margin-bottom: 25px;
 }
 .tabHeader div{
    font-size: 18px;
    cursor: pointer;
    margin-left: 16px;
 }
.tabHeader .inactive{
    color: var(--placeholder-grey);
    font-family: var(--inter-Medium500);
}
.tabHeader .active{
    color: var(--light-black);
    font-family: var(--Inter-Bold700);
    border-bottom: 2px solid black;
}
 .item-wrapper .key {
     color: var(--text-color);
     font-family: var(--inter-Medium500);
     font-size: 14px;
     line-height: 20px;
     letter-spacing: -0.28px;
     width: 150px;
     padding-right: 10px !important;
 }

 .item-wrapper .overlap-3 {
     background-color: #f4f7fe;
     border-radius: 49px;
     width: 70%;
     min-height: 43px;
     border-radius: 49px;
     background: #F4F7FE;
     padding: 11px 43px;
 }

 .item-wrapper .overlap-3 .span-wrapper {
     color: #1E1E1E;
     font-family: var(--inter-Medium500);
     font-size: 14px;
     line-height: 20px;
     letter-spacing: -0.28px;
     word-break: break-all
 }

 /***********************user Response styles**********************/

 .user-response-container {
     /* margin-top: 31px; */
     box-shadow: 0px 0px 40px 0px rgba(112, 144, 176, 0.12);
     padding: 18px 0px;
 }

 .user-respose-wrapper {
     padding: 0px 18px;
     /* height: 200px; */
     overflow: auto;
 }

 .user-respose-wrapper .user-response-header .coach-header .left-box>p:nth-child(2) {
     margin-left: 40px !important;
     margin-top: 19px !important;
 }

 .user-respose-wrapper .user-response-header .coach-header .right-box {
     align-items: start !important;
 }

 /* .user-respose-wrapper .user-questionnair-history-wrapper {
     margin-left: 40px;
 } */

 .user-respose-wrapper .user-questionnair-history-wrapper .date-timelist-wrapper {
     display: flex;
     flex-direction: row;
     justify-content: flex-start;
     gap: 20px;
     flex-wrap: wrap;
     margin-bottom: 25px;
 }

 .user-respose-wrapper .user-questionnair-history-wrapper .date-timelist-wrapper .date-time-item {
     border-radius: 7px;
     background: var(--field-background);
     padding: 4px 21px !important;
     color: var(--light-black);
     text-align: center;
     font-family: var(--Inter-SemiBold600);
     font-size: 14px;
     line-height: 26px;
     letter-spacing: -0.28px;
     width: 201px;
     /* margin-bottom: 20px !important; */
 }

 .date-time-item-active {
     color: var(--purple) !important
 }
 .question-container-wrapper {
     margin-top: 10px !important;
 }

 .question-container-wrapper .question-title-wrapper {
     border-radius: 7px;
     background: var(--field-background);
     width: 100%;
     display: flex;
     flex-direction: row;
     justify-content: space-between;
     padding: 4px 25px 4px 23px !important;
 }

 .question-container-wrapper .question-title-wrapper .left-arrow.upWard {
     transform: rotate(0deg) !important;
 }

 .question-container-wrapper .question-title-wrapper .left-arrow.downWard {
     transform: rotate(180deg) !important;
 }

 .question-container-wrapper .question-title-wrapper>img {
     width: 9px;
     height: 4px;
     align-self: center;
 }


 .question-deatil-wrapper {
     margin-top: 14px;
     margin-bottom: 20px;
 }

 .question-deatil-wrapper .response {
     margin: 15px 0px !important;
     color: var(--text-color);
     font-size: 14px !important;
     font-family: var(--inter-Medium500);
 }

 .question-deatil-wrapper .response>span {
     font-family: var(--Inter-Bold700);
 }

 .question-deatil-wrapper .client-note-wrapper {
     display: flex;
     flex-direction: row;
     justify-content: space-between;
     margin-bottom: 12px !important;
 }

 .question-deatil-wrapper .client-note-wrapper .text-wrapper-1 {
     margin-bottom: 0px !important;
 }

 .question-deatil-wrapper .text.extra-comment {
     color: var(--text-color1);
 }

 /* .date-timelist-wrapper p {
    cursor: pointer;
} */

 .date-timelist-wrapper p:hover {
     cursor: pointer;
     opacity: 0.8;
     /* background: var(--background-color1) !important; */
 }

 .client-detail-content-container {
     overflow: auto;
     /* height: calc(435px - 70px); */
     flex: 1 1;
     padding: 0px 18px;
 }

 .padding18 {
     padding: 0px 18px;
 }

 .marginBottom15 {
     margin-bottom: 15px;
 }




 /************@media quesris****************/



 @media(min-width:1920px) {

     .user-info-subcontainer .second-box,
     .user-info-subcontainer .third-box {
         flex-grow: 1;
     }
 }

 @media(max-width:1700px) {
     .user-info-subcontainer {
         flex-wrap: wrap;
     }

     .item-wrapper .overlap-3 {
         padding: 11px 20px;
     }

 }

 @media(max-width:1200px) {
     .user-info-subcontainer .second-box {
         margin-right: 0px;
     }

     .user-info-subcontainer .third-box {
         flex: none;
         width: 100%;
     }
 }

 @media(max-width:992px) {
     .user-info-subcontainer .first-box {
         margin-right: 0px;
     }

     .user-info-subcontainer .second-box,
     .user-info-subcontainer .third-box {
         flex: none;
         width: 100%;
     }

     .user-respose-wrapper .user-response-header .coach-header .left-box>p:nth-child(2),
     .user-respose-wrapper .user-questionnair-history-wrapper {
         margin-left: 0px !important;
     }

 }

 @media(max-width:575px) {

     .client-detail-wrapper .item-wrapper .sub-item-wrapper {
         flex-direction: column;
     }

     .client-detail-wrapper .item-wrapper .sub-item-wrapper .sub-item-wrapper-1 {
         width: 100%;
         justify-content: space-between;
         margin-bottom: 15px;
     }

     .client-detail-wrapper .item-wrapper .sub-item-wrapper .key {
         width: 150px;
     }

     .client-detail-wrapper .item-wrapper .sub-item-wrapper .sub-item-wrapper-1 .overlap-3 {
         margin-left: 0px;
         margin-bottom: 0px;
         width: 70%;
     }

     .client-detail-wrapper .item-wrapper .sub-item-wrapper .sub-item-wrapper-2 {
         width: 100%;
         justify-content: space-between;
     }

     .client-detail-wrapper .item-wrapper .sub-item-wrapper-2 .key {
         width: 150px !important;
         margin-left: 0px !important;
     }

     .client-detail-wrapper .item-wrapper .sub-item-wrapper .sub-item-wrapper-2 .overlap-3 {
         margin-bottom: 0px;
         margin-left: 0px;
         width: 70% !important;
     }

     .item-wrapper .address-overlap-3-wrapper .overlap-3 {
         width: 100%;
     }

     .user-respose-wrapper .user-response-header .coach-header .left-box>p:nth-child(2) {
         margin-left: 0px !important;
         margin-top: 7px !important;
     }

     .user-respose-wrapper .user-questionnair-history-wrapper {
         margin-left: 0px;
     }

     .user-respose-wrapper .user-response-header .header.coach-header .right-box {
         position: relative;
         margin-top: 0px !important;
         right: 0px !important;
     }
 }`, "",{"version":3,"sources":["webpack://./src/screens/common/clientDetailPage/ClientDetailPage.css"],"names":[],"mappings":"CAAC;KACI,aAAa;KACb,mBAAmB;KACnB,eAAe;;CAEnB;;CAEA;KACI,6BAA6B;CACjC;;CAEA;KACI,YAAY;CAChB;;CAEA;KACI,uBAAuB;CAC3B;;CAEA;KACI,aAAa;KACb,mBAAmB;KACnB,8BAA8B;CAClC;;;;CAIA,wCAAwC;CACxC;;;KAGI,aAAa;KACb,SAAO;KACP,sBAAsB;KACtB,kBAAkB;CACtB;;CAEA;KACI,iBAAiB;CACrB;;;CAGA;;;;;;KAMI,aAAa;KACb,oBAAoB;KACpB,mBAAmB;CACvB;;;CAGA;KACI,mBAAmB;KACnB,wBAAwB;KACxB,uDAAuD;KACvD,2BAA2B;KAC3B,aAAa;CACjB;;CAEA;KACI,yBAAyB;KACzB,iCAAiC;KACjC,eAAe;KACf,gBAAgB;KAChB,iBAAiB;CACrB;;CAEA;KACI,yBAAyB;KACzB,iCAAiC;KACjC,eAAe;KACf,iBAAiB;KACjB,uBAAuB;KACvB,8BAA8B;CAClC;;CAEA;KACI,wBAAwB;KACxB,mCAAmC;KACnC,eAAe;KACf,iBAAiB;KACjB,uBAAuB;KACvB,qBAAqB;KACrB,mBAAmB;KACnB,sBAAsB;CAC1B;;CAEA;KACI,yBAAyB;KACzB,mCAAmC;KACnC,eAAe;KACf,iBAAiB;KACjB,uBAAuB;CAC3B;;CAEA;KACI,wBAAwB;KACxB,kBAAkB;KAClB,mCAAmC;KACnC,eAAe;KACf,iBAAiB;KACjB,uBAAuB;KACvB,mBAAmB;CACvB;;;CAGA,UAAU;CACV;KACI,UAAU;CACd;;CAEA,UAAU;CACV;KACI,mBAAmB;KACnB,gBAAgB;KAChB,mBAAmB;CACvB;;CAEA,WAAW;CACX;KACI,+BAA+B;KAC/B,iCAAiC;KACjC,mBAAmB;CACvB;;CAEA,oBAAoB;CACpB;;GAEE;;;;CAIF,sDAAsD;CACtD;KACI,wBAAwB;CAC5B;;CAEA;KACI,iBAAiB;CACrB;;;CAGA,8EAA8E;CAC9E;KACI,wBAAwB;CAC5B;;CAEA,4EAA4E;;CAE5E;KACI,mBAAmB;CACvB;;CAEA;KACI,aAAa;KACb,mBAAmB;KACnB,8BAA8B;CAClC;;;CAGA;KACI,mBAAmB;CACvB;;CAEA;KACI,aAAa;KACb,mBAAmB;KACnB,8BAA8B;KAC9B,mBAAmB;KACnB,iBAAiB;CACrB;;CAEA;KACI,0BAA0B;KAC1B,uBAAuB;KACvB,gBAAgB;KAChB,aAAa;KACb,uBAAuB;KACvB,mBAAmB;KACnB,8BAA8B;KAC9B,0BAA0B;KAC1B,8CAA8C;KAC9C,YAAY;CAChB;;CAEA;KACI,eAAe;KACf,YAAY;CAChB;;CAEA;KACI,WAAW;KACX,YAAY;CAChB;;CAEA;KACI,aAAa;KACb,sBAAsB;KACtB,cAAc;KACd,SAAO;KACP,iBAAiB;;CAErB;;CAEA,+DAA+D;;;;CAI/D;KACI,gBAAgB;CACpB;;CAEA;KACI,aAAa;KACb,mBAAmB;KACnB,8BAA8B;KAC9B,mBAAmB;KACnB,mBAAmB;CACvB;;CAEA;KACI,WAAW;KACX,aAAa;KACb,mBAAmB;KACnB,mBAAmB;CACvB;;CAEA;KACI,aAAa;KACb,mBAAmB;KACnB,mBAAmB;KACnB,UAAU;KACV,8BAA8B;KAC9B,wBAAwB;CAC5B;;CAEA;KACI,aAAa;KACb,mBAAmB;KACnB,mBAAmB;KACnB,UAAU;KACV,kBAAkB;CACtB;;CAEA;KACI,kBAAkB;KAClB,WAAW;CACf;;;CAGA;KACI,iBAAiB;KACjB,kBAAkB;KAClB,UAAU;CACd;;CAEA;KACI,sBAAsB;KACtB,4BAA4B;CAChC;;CAEA;KACI,kBAAkB;KAClB,sBAAsB;CAC1B;;CAEA;KACI,sBAAsB;CAC1B;;CAEA;KACI,aAAa;KACb,mBAAmB;KACnB,8BAA8B;KAC9B,UAAU;KACV,eAAe;;CAEnB;;CAEA;KACI,UAAU;KACV,mBAAmB;CACvB;CACA;IACG,wBAAwB;IACxB,mBAAmB;CACtB;CACA;IACG,eAAe;IACf,eAAe;IACf,iBAAiB;CACpB;AACD;IACI,8BAA8B;IAC9B,mCAAmC;AACvC;AACA;IACI,yBAAyB;IACzB,iCAAiC;IACjC,8BAA8B;AAClC;CACC;KACI,wBAAwB;KACxB,mCAAmC;KACnC,eAAe;KACf,iBAAiB;KACjB,uBAAuB;KACvB,YAAY;KACZ,8BAA8B;CAClC;;CAEA;KACI,yBAAyB;KACzB,mBAAmB;KACnB,UAAU;KACV,gBAAgB;KAChB,mBAAmB;KACnB,mBAAmB;KACnB,kBAAkB;CACtB;;CAEA;KACI,cAAc;KACd,mCAAmC;KACnC,eAAe;KACf,iBAAiB;KACjB,uBAAuB;KACvB;CACJ;;CAEA,kEAAkE;;CAElE;KACI,sBAAsB;KACtB,sDAAsD;KACtD,iBAAiB;CACrB;;CAEA;KACI,iBAAiB;KACjB,mBAAmB;KACnB,cAAc;CAClB;;CAEA;KACI,4BAA4B;KAC5B,2BAA2B;CAC/B;;CAEA;KACI,6BAA6B;CACjC;;CAEA;;IAEG;;CAEH;KACI,aAAa;KACb,mBAAmB;KACnB,2BAA2B;KAC3B,SAAS;KACT,eAAe;KACf,mBAAmB;CACvB;;CAEA;KACI,kBAAkB;KAClB,mCAAmC;KACnC,4BAA4B;KAC5B,yBAAyB;KACzB,kBAAkB;KAClB,qCAAqC;KACrC,eAAe;KACf,iBAAiB;KACjB,uBAAuB;KACvB,YAAY;KACZ,oCAAoC;CACxC;;CAEA;KACI;CACJ;CACA;KACI,2BAA2B;CAC/B;;CAEA;KACI,kBAAkB;KAClB,mCAAmC;KACnC,WAAW;KACX,aAAa;KACb,mBAAmB;KACnB,8BAA8B;KAC9B,qCAAqC;CACzC;;CAEA;KACI,kCAAkC;CACtC;;CAEA;KACI,oCAAoC;CACxC;;CAEA;KACI,UAAU;KACV,WAAW;KACX,kBAAkB;CACtB;;;CAGA;KACI,gBAAgB;KAChB,mBAAmB;CACvB;;CAEA;KACI,2BAA2B;KAC3B,wBAAwB;KACxB,0BAA0B;KAC1B,mCAAmC;CACvC;;CAEA;KACI,iCAAiC;CACrC;;CAEA;KACI,aAAa;KACb,mBAAmB;KACnB,8BAA8B;KAC9B,8BAA8B;CAClC;;CAEA;KACI,6BAA6B;CACjC;;CAEA;KACI,yBAAyB;CAC7B;;CAEA;;GAEE;;CAEF;KACI,eAAe;KACf,YAAY;KACZ,qDAAqD;CACzD;;CAEA;KACI,cAAc;KACd,gCAAgC;KAChC,SAAO;KACP,iBAAiB;CACrB;;CAEA;KACI,iBAAiB;CACrB;;CAEA;KACI,mBAAmB;CACvB;;;;;CAKA,2CAA2C;;;;CAI3C;;KAEI;;SAEI,YAAY;KAChB;CACJ;;CAEA;KACI;SACI,eAAe;KACnB;;KAEA;SACI,kBAAkB;KACtB;;CAEJ;;CAEA;KACI;SACI,iBAAiB;KACrB;;KAEA;SACI,UAAU;SACV,WAAW;KACf;CACJ;;CAEA;KACI;SACI,iBAAiB;KACrB;;KAEA;;SAEI,UAAU;SACV,WAAW;KACf;;KAEA;;SAEI,2BAA2B;KAC/B;;CAEJ;;CAEA;;KAEI;SACI,sBAAsB;KAC1B;;KAEA;SACI,WAAW;SACX,8BAA8B;SAC9B,mBAAmB;KACvB;;KAEA;SACI,YAAY;KAChB;;KAEA;SACI,gBAAgB;SAChB,kBAAkB;SAClB,UAAU;KACd;;KAEA;SACI,WAAW;SACX,8BAA8B;KAClC;;KAEA;SACI,uBAAuB;SACvB,2BAA2B;KAC/B;;KAEA;SACI,kBAAkB;SAClB,gBAAgB;SAChB,qBAAqB;KACzB;;KAEA;SACI,WAAW;KACf;;KAEA;SACI,2BAA2B;SAC3B,0BAA0B;KAC9B;;KAEA;SACI,gBAAgB;KACpB;;KAEA;SACI,kBAAkB;SAClB,0BAA0B;SAC1B,qBAAqB;KACzB;CACJ","sourcesContent":[" .user-detail-header .header-button-wrapper {\n     display: flex;\n     flex-direction: row;\n     margin-top: 5px;\n\n }\n\n .user-detail-header .header-button-wrapper>button:first-child {\n     margin-right: 20px !important;\n }\n\n .user-detail-header .header-button-wrapper>button:first-child:hover {\n     cursor: auto;\n }\n\n .user-detail-header .header-button-wrapper>button:nth-child(2):hover {\n     opacity: 0.8 !important;\n }\n\n .user-info-subcontainer {\n     display: flex;\n     flex-direction: row;\n     justify-content: space-between;\n }\n\n\n\n /**********common***********************/\n .user-info-subcontainer .first-box,\n .user-info-subcontainer .second-box,\n .user-info-subcontainer .third-box {\n     display: flex;\n     flex: 1;\n     flex-direction: column;\n     margin-right: 25px;\n }\n\n .user-info-subcontainer .third-box {\n     margin-right: 0px;\n }\n\n\n .user-info-subcontainer .third-box .client-coach-feedback-box,\n .user-info-subcontainer .third-box .client-history-box,\n .user-info-subcontainer .second-box .client-health-box,\n .user-info-subcontainer .second-box .client-report-box,\n .user-info-subcontainer .first-box .client-history-box,\n .user-info-subcontainer .first-box .client-intro-box {\n     height: 435px;\n     /* overflow: auto; */\n     margin-bottom: 31px;\n }\n\n\n .common-card {\n     border-radius: 15px;\n     background: var(--white);\n     box-shadow: 0px 18px 40px 0px rgba(112, 144, 176, 0.12);\n     /* border: 1px solid red; */\n     padding: 18px;\n }\n\n .common-card .text-wrapper-2 {\n     color: var(--light-black);\n     font-family: \"DM Sans\", Helvetica;\n     font-size: 22px;\n     font-weight: 700;\n     line-height: 32px;\n }\n\n .text-wrapper-1 {\n     color: var(--light-black);\n     font-family: var(--Inter-Bold700);\n     font-size: 18px;\n     line-height: 28px;\n     letter-spacing: -0.36px;\n     margin-bottom: 15px !important;\n }\n\n .text {\n     color: var(--text-color);\n     font-family: var(--inter-Medium500);\n     font-size: 16px;\n     line-height: 26px;\n     letter-spacing: -0.32px;\n     white-space: pre-wrap;\n     text-align: justify;\n     word-break: break-word;\n }\n\n .question-title {\n     color: var(--light-black);\n     font-family: var(--inter-Medium500);\n     font-size: 14px;\n     line-height: 26px;\n     letter-spacing: -0.28px;\n }\n\n .date {\n     color: var(--text-color);\n     text-align: center;\n     font-family: var(--inter-Medium500);\n     font-size: 14px;\n     line-height: 26px;\n     letter-spacing: -0.28px;\n     margin-bottom: 30px;\n }\n\n\n /* width */\n .internal-scroll::-webkit-scrollbar {\n     width: 3px;\n }\n\n /* Track */\n .internal-scroll::-webkit-scrollbar-track {\n     background: #f1f1f1;\n     margin: 10px 0px;\n     border-radius: 15px;\n }\n\n /* Handle */\n .internal-scroll::-webkit-scrollbar-thumb {\n     /* background: var(--purple); */\n     background: var(--disbaled-color);\n     border-radius: 15px;\n }\n\n /* Handle on hover */\n /* ::-webkit-scrollbar-thumb:hover {\n    background: #555;\n} */\n\n\n\n /*******************First box styles start************/\n .user-info-subcontainer .first-box {\n     /* margin-right: 31px; */\n }\n\n .user-info-subcontainer .first-box .client-info-box {\n     min-height: 750px;\n }\n\n\n /********************first box style end &&&& second box start****************/\n .user-info-subcontainer .second-box {\n     /* margin-right: 31px; */\n }\n\n /******************* second box style end &&&&& third box start ************/\n\n .user-info-subcontainer .third-box .client-history-box .text-wrapper-2 {\n     margin-bottom: 16px;\n }\n\n .user-info-subcontainer .third-box .client-history-box .date-container {\n     display: flex;\n     flex-direction: row;\n     justify-content: space-between;\n }\n\n\n .user-info-subcontainer .third-box .client-history-box .active-question-wrapper {\n     margin-bottom: 10px;\n }\n\n .user-info-subcontainer .third-box .client-coach-feedback-box .feadback-header {\n     display: flex;\n     flex-direction: row;\n     justify-content: space-between;\n     margin-bottom: 15px;\n     padding: 0px 18px;\n }\n\n .addfeedback-button {\n     width: 91.654px !important;\n     height: 35px !important;\n     padding: 0px 8px;\n     display: flex;\n     justify-content: center;\n     align-items: center;\n     border-radius: 12px !important;\n     font-size: 18px !important;\n     background: var(--field-background) !important;\n     border: none;\n }\n\n .addfeedback-button:hover {\n     cursor: pointer;\n     opacity: 0.8;\n }\n\n .addfeedback-button img {\n     width: 18px;\n     height: 17px;\n }\n\n .client-coach-feedback-box .feedback-list-wrapper {\n     display: flex;\n     flex-direction: column;\n     overflow: auto;\n     flex: 1;\n     padding: 0px 18px;\n\n }\n\n /********************third box end ****************************/\n\n\n\n .client-detail-wrapper {\n     margin-top: 31px;\n }\n\n .client-detail-wrapper .item-wrapper {\n     display: flex;\n     flex-direction: row;\n     justify-content: space-between;\n     align-items: center;\n     margin-bottom: 15px;\n }\n\n .client-detail-wrapper .item-wrapper .sub-item-wrapper {\n     width: 100%;\n     display: flex;\n     flex-direction: row;\n     align-items: center;\n }\n\n .client-detail-wrapper .item-wrapper .sub-item-wrapper .sub-item-wrapper-1 {\n     display: flex;\n     flex-direction: row;\n     align-items: center;\n     width: 60%;\n     justify-content: space-between;\n     /* margin-right: 20px; */\n }\n\n .client-detail-wrapper .item-wrapper .sub-item-wrapper .sub-item-wrapper-2 {\n     display: flex;\n     flex-direction: row;\n     align-items: center;\n     width: 40%;\n     align-self: center;\n }\n\n .client-detail-wrapper .item-wrapper .sub-item-wrapper .key {\n     /* width: 150px; */\n     width: auto;\n }\n\n\n .client-detail-wrapper .item-wrapper .sub-item-wrapper .sub-item-wrapper-1 .overlap-3 {\n     margin-left: 92px;\n     margin-bottom: 0px;\n     width: 50%;\n }\n\n .client-detail-wrapper .item-wrapper .sub-item-wrapper-2 .key {\n     width: 50px !important;\n     margin-left: 20px !important;\n }\n\n .client-detail-wrapper .item-wrapper .sub-item-wrapper .sub-item-wrapper-2 .overlap-3 {\n     margin-bottom: 0px;\n     width: 100% !important;\n }\n\n .item-wrapper.address-wrapper .key {\n     align-self: flex-start;\n }\n\n .item-wrapper .address-overlap-3-wrapper {\n     display: flex;\n     flex-direction: row;\n     justify-content: space-between;\n     width: 70%;\n     flex-wrap: wrap;\n\n }\n\n .item-wrapper .address-overlap-3-wrapper .overlap-3 {\n     width: 48%;\n     margin-bottom: 15px;\n }\n .tabHeader{\n    display: flex !important;\n    margin-bottom: 25px;\n }\n .tabHeader div{\n    font-size: 18px;\n    cursor: pointer;\n    margin-left: 16px;\n }\n.tabHeader .inactive{\n    color: var(--placeholder-grey);\n    font-family: var(--inter-Medium500);\n}\n.tabHeader .active{\n    color: var(--light-black);\n    font-family: var(--Inter-Bold700);\n    border-bottom: 2px solid black;\n}\n .item-wrapper .key {\n     color: var(--text-color);\n     font-family: var(--inter-Medium500);\n     font-size: 14px;\n     line-height: 20px;\n     letter-spacing: -0.28px;\n     width: 150px;\n     padding-right: 10px !important;\n }\n\n .item-wrapper .overlap-3 {\n     background-color: #f4f7fe;\n     border-radius: 49px;\n     width: 70%;\n     min-height: 43px;\n     border-radius: 49px;\n     background: #F4F7FE;\n     padding: 11px 43px;\n }\n\n .item-wrapper .overlap-3 .span-wrapper {\n     color: #1E1E1E;\n     font-family: var(--inter-Medium500);\n     font-size: 14px;\n     line-height: 20px;\n     letter-spacing: -0.28px;\n     word-break: break-all\n }\n\n /***********************user Response styles**********************/\n\n .user-response-container {\n     /* margin-top: 31px; */\n     box-shadow: 0px 0px 40px 0px rgba(112, 144, 176, 0.12);\n     padding: 18px 0px;\n }\n\n .user-respose-wrapper {\n     padding: 0px 18px;\n     /* height: 200px; */\n     overflow: auto;\n }\n\n .user-respose-wrapper .user-response-header .coach-header .left-box>p:nth-child(2) {\n     margin-left: 40px !important;\n     margin-top: 19px !important;\n }\n\n .user-respose-wrapper .user-response-header .coach-header .right-box {\n     align-items: start !important;\n }\n\n /* .user-respose-wrapper .user-questionnair-history-wrapper {\n     margin-left: 40px;\n } */\n\n .user-respose-wrapper .user-questionnair-history-wrapper .date-timelist-wrapper {\n     display: flex;\n     flex-direction: row;\n     justify-content: flex-start;\n     gap: 20px;\n     flex-wrap: wrap;\n     margin-bottom: 25px;\n }\n\n .user-respose-wrapper .user-questionnair-history-wrapper .date-timelist-wrapper .date-time-item {\n     border-radius: 7px;\n     background: var(--field-background);\n     padding: 4px 21px !important;\n     color: var(--light-black);\n     text-align: center;\n     font-family: var(--Inter-SemiBold600);\n     font-size: 14px;\n     line-height: 26px;\n     letter-spacing: -0.28px;\n     width: 201px;\n     /* margin-bottom: 20px !important; */\n }\n\n .date-time-item-active {\n     color: var(--purple) !important\n }\n .question-container-wrapper {\n     margin-top: 10px !important;\n }\n\n .question-container-wrapper .question-title-wrapper {\n     border-radius: 7px;\n     background: var(--field-background);\n     width: 100%;\n     display: flex;\n     flex-direction: row;\n     justify-content: space-between;\n     padding: 4px 25px 4px 23px !important;\n }\n\n .question-container-wrapper .question-title-wrapper .left-arrow.upWard {\n     transform: rotate(0deg) !important;\n }\n\n .question-container-wrapper .question-title-wrapper .left-arrow.downWard {\n     transform: rotate(180deg) !important;\n }\n\n .question-container-wrapper .question-title-wrapper>img {\n     width: 9px;\n     height: 4px;\n     align-self: center;\n }\n\n\n .question-deatil-wrapper {\n     margin-top: 14px;\n     margin-bottom: 20px;\n }\n\n .question-deatil-wrapper .response {\n     margin: 15px 0px !important;\n     color: var(--text-color);\n     font-size: 14px !important;\n     font-family: var(--inter-Medium500);\n }\n\n .question-deatil-wrapper .response>span {\n     font-family: var(--Inter-Bold700);\n }\n\n .question-deatil-wrapper .client-note-wrapper {\n     display: flex;\n     flex-direction: row;\n     justify-content: space-between;\n     margin-bottom: 12px !important;\n }\n\n .question-deatil-wrapper .client-note-wrapper .text-wrapper-1 {\n     margin-bottom: 0px !important;\n }\n\n .question-deatil-wrapper .text.extra-comment {\n     color: var(--text-color1);\n }\n\n /* .date-timelist-wrapper p {\n    cursor: pointer;\n} */\n\n .date-timelist-wrapper p:hover {\n     cursor: pointer;\n     opacity: 0.8;\n     /* background: var(--background-color1) !important; */\n }\n\n .client-detail-content-container {\n     overflow: auto;\n     /* height: calc(435px - 70px); */\n     flex: 1;\n     padding: 0px 18px;\n }\n\n .padding18 {\n     padding: 0px 18px;\n }\n\n .marginBottom15 {\n     margin-bottom: 15px;\n }\n\n\n\n\n /************@media quesris****************/\n\n\n\n @media(min-width:1920px) {\n\n     .user-info-subcontainer .second-box,\n     .user-info-subcontainer .third-box {\n         flex-grow: 1;\n     }\n }\n\n @media(max-width:1700px) {\n     .user-info-subcontainer {\n         flex-wrap: wrap;\n     }\n\n     .item-wrapper .overlap-3 {\n         padding: 11px 20px;\n     }\n\n }\n\n @media(max-width:1200px) {\n     .user-info-subcontainer .second-box {\n         margin-right: 0px;\n     }\n\n     .user-info-subcontainer .third-box {\n         flex: none;\n         width: 100%;\n     }\n }\n\n @media(max-width:992px) {\n     .user-info-subcontainer .first-box {\n         margin-right: 0px;\n     }\n\n     .user-info-subcontainer .second-box,\n     .user-info-subcontainer .third-box {\n         flex: none;\n         width: 100%;\n     }\n\n     .user-respose-wrapper .user-response-header .coach-header .left-box>p:nth-child(2),\n     .user-respose-wrapper .user-questionnair-history-wrapper {\n         margin-left: 0px !important;\n     }\n\n }\n\n @media(max-width:575px) {\n\n     .client-detail-wrapper .item-wrapper .sub-item-wrapper {\n         flex-direction: column;\n     }\n\n     .client-detail-wrapper .item-wrapper .sub-item-wrapper .sub-item-wrapper-1 {\n         width: 100%;\n         justify-content: space-between;\n         margin-bottom: 15px;\n     }\n\n     .client-detail-wrapper .item-wrapper .sub-item-wrapper .key {\n         width: 150px;\n     }\n\n     .client-detail-wrapper .item-wrapper .sub-item-wrapper .sub-item-wrapper-1 .overlap-3 {\n         margin-left: 0px;\n         margin-bottom: 0px;\n         width: 70%;\n     }\n\n     .client-detail-wrapper .item-wrapper .sub-item-wrapper .sub-item-wrapper-2 {\n         width: 100%;\n         justify-content: space-between;\n     }\n\n     .client-detail-wrapper .item-wrapper .sub-item-wrapper-2 .key {\n         width: 150px !important;\n         margin-left: 0px !important;\n     }\n\n     .client-detail-wrapper .item-wrapper .sub-item-wrapper .sub-item-wrapper-2 .overlap-3 {\n         margin-bottom: 0px;\n         margin-left: 0px;\n         width: 70% !important;\n     }\n\n     .item-wrapper .address-overlap-3-wrapper .overlap-3 {\n         width: 100%;\n     }\n\n     .user-respose-wrapper .user-response-header .coach-header .left-box>p:nth-child(2) {\n         margin-left: 0px !important;\n         margin-top: 7px !important;\n     }\n\n     .user-respose-wrapper .user-questionnair-history-wrapper {\n         margin-left: 0px;\n     }\n\n     .user-respose-wrapper .user-response-header .header.coach-header .right-box {\n         position: relative;\n         margin-top: 0px !important;\n         right: 0px !important;\n     }\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
